import { useSelector, } from 'react-redux';
import { IGlobalStore, IReducerStore, } from '@Store';

export const useDisplayAudioSettings = (): IGlobalStore['display_audio_settings'] => {
  return useSelector((store: IReducerStore) => store.global.display_audio_settings);
};
